import { useTheme } from '@mui/material';
import { CustomToolTip } from 'modules';
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';



export type AreaChartBaseProps = {
  data?: { name: string; rate: string }[];
  yDomain?: [number, number];
};

export const FC = (props: AreaChartBaseProps) => {
  const { data } = props;
  const theme = useTheme();

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer
        width='100%'
        height='100%'
      >
        <AreaChart
          width={400}
          height={300}
          margin={{
            right: 5, bottom: 5, left: 0
          }}
          data={data}
        >
          <defs>
            <linearGradient
              id='rate'
              x1='0'
              y1='-.5'
              x2='1'
              y2='1'
            >
              <stop
                offset='0'
                stopColor='#02C37E'
                stopOpacity={0.8}
              />
              <stop
                offset='95%'
                stopColor='#82ca9d'
                stopOpacity={0}
              />
            </linearGradient>
          </defs>


          <Tooltip content={(
            <CustomToolTip.FC
              type='AREA'
              active={true}
              label='name'
              payload={data ?? []}
            />
          )}
          />

          <YAxis
            domain={props.yDomain}
            type='number'
            fontFamily='Lexend'
            label={{
              id: 'testing',
              classNames: 'recharts-xAxis',
              value: 'Interest Rate',
              angle: -90
            }}
          />

          <Area
            type='monotone'
            dataKey='rate'
            stroke={theme.palette.primary.main}
            fillOpacity={1}
            fill='url(#rate)'
          />
          <XAxis
            fontFamily='Lexend'
            padding={{
              left: 0
            }}
            interval='preserveEnd'
            label={{
              value: 'Duration',
              position: 'insideBottomRight',
              offset: 0
            }}
            dataKey='name'
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
